// Валидация
document.querySelectorAll('form.form').forEach((form) => {
	const submitButton = form.querySelector('.form__button');
	// let widgetId;

	// Обработка событий ввода
	[...form.elements].forEach((element) => {
		if (
			element.classList.contains('form__input') ||
			element.classList.contains('form__checkbox-input')
		) {
			const container = element.closest('.form__item');

			const eventList = ['change', 'input']; // Клик или

			eventList.forEach((event) => {
				element.addEventListener(event, () => {
					if (
						element.type === 'text' ||
						element.type === 'textarea' ||
						element.type === 'email' ||
						element.type === 'password'
					) {
						if (element.validity.valid) {
							container.classList.remove('form__item--error');
						} else {
							submitButton.setAttribute('disabled', 'disabled');
							container.classList.add('form__item--error');
						}

						if (form.checkValidity()) {
							submitButton.removeAttribute('disabled');
						} else {
							submitButton.setAttribute('disabled', 'disabled');
						}
					}

					if (element.type === 'tel') {
						if (element.value.length >= 16) {
							container.classList.remove('form__item--error');
						} else {
							submitButton.setAttribute('disabled', 'disabled');
							container.classList.add('form__item--error');
						}

						if (form.checkValidity()) {
							submitButton.removeAttribute('disabled');
						} else {
							submitButton.setAttribute('disabled', 'disabled');
						}
					}

					if (form.querySelector('input[name="smart-token"]')) {
						if (
							form.checkValidity() &&
							form.querySelector('input[name="smart-token"]').value !== ''
						) {
							submitButton.removeAttribute('disabled');
						} else {
							submitButton.setAttribute('disabled', 'disabled');
						}
					} else if (form.checkValidity()) {
						submitButton.removeAttribute('disabled');
					} else {
						submitButton.setAttribute('disabled', 'disabled');
					}

					if (form.querySelector('#pass') && form.querySelector('#pass2')) {
						if (
							form.querySelector('#pass').value !==
								form.querySelector('#pass2').value ||
							form.querySelector('#pass').value.length < 6
						) {
							form
								.querySelector('#pass')
								.closest('.form__item')
								.classList.add('form__item--error');
							form
								.querySelector('#pass2')
								.closest('.form__item')
								.classList.add('form__item--error');
							submitButton.setAttribute('disabled', 'disabled');
						} else {
							form
								.querySelector('#pass')
								.closest('.form__item')
								.classList.remove('form__item--error');
							form
								.querySelector('#pass2')
								.closest('.form__item')
								.classList.remove('form__item--error');
						}
					}
				});
			});
		}
	});
});
